<template>
    <v-dialog v-model="dialog" persistent max-width="500px">
        <v-card>
            <v-form>
                <v-toolbar flat dense cad>
                    <v-toolbar-title class="subheading">{{ title }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>

                <v-divider></v-divider>
                <v-card-text>
                    <v-textarea 
                        v-model="form.question" 
                        :error-messages="questionErrors" 
                        box
                        label="Question" 
                        auto-grow rows="2"
                        required 
                        ref="questionField" 
                        @input="$v.form.question.$touch()" 
                        @blur="$v.form.question.$touch()">
                    </v-textarea>

                    <div style="text-align: left">
                        How would you like this question to be answered?
                    </div>

                    <v-radio-group v-model="form.rankType" :mandatory="true">
                        <v-radio label="Text" :value="0"></v-radio>
                        <v-radio label="Traffic Light Ranking" :value="1"></v-radio>
                        <v-radio label="Happiness Scale" :value="2"></v-radio>
                    </v-radio-group>

                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @click="closeEditor">Cancel</v-btn>
                    <v-btn color="primary" flat @click="submit">Save</v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script>
    import { validationMixin } from 'vuelidate';
    import { required } from 'vuelidate/lib/validators';

    export default {
    	props: {
    		item: {
    			type: Object,
                required: false,
                default: () => ({
					id: null,
                    question: null,
                    rankType: 0, 
                    answer: null
				})
    		},
    		dialog: {},
    		title: {
    			required: true,
    			type: String
            }
        },
        mounted() {
            this.$nextTick(() => this.$refs.questionField.focus());
        },
        data() {
            return {
                form: {
                    id: this.item.id,
                    question: this.item.question,
                    rankType: this.item.rankType,
                    answer: this.item.answer
                }
            }
        },
        computed: {
            questionErrors() {
                const errors = [];
                if (!this.$v.form.question.$dirty) return errors;
                !this.$v.form.question.required && errors.push('Question is required.');
                return errors;
            }
        },
        mixins: [validationMixin],
        validations: {
            form: {
                question: { required }
            }
        },
        methods: {
            closeEditor() {
                this.$emit('closeEditor');
            },
            submit() {
                this.$v.form.$touch();

				if (this.$v.form.$invalid) {
					console.log('invalid form');
				} else {
					let postObj = {
						id: this.form.id != undefined ? this.form.id : this.newGuid(),
                        question: this.form.question,
                        rankType: this.form.rankType,
                        answer: null
					};
					this.$emit('save', postObj);
					this.closeEditor();
				}
            }
        }       
    }
</script>

<style>
</style>
